import { render, staticRenderFns } from "./VModal.vue?vue&type=template&id=1ffa1f76&scoped=true"
import script from "./VModal.vue?vue&type=script&lang=js"
export * from "./VModal.vue?vue&type=script&lang=js"
import style0 from "./VModal.vue?vue&type=style&index=0&id=1ffa1f76&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffa1f76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ffa1f76')) {
      api.createRecord('1ffa1f76', component.options)
    } else {
      api.reload('1ffa1f76', component.options)
    }
    module.hot.accept("./VModal.vue?vue&type=template&id=1ffa1f76&scoped=true", function () {
      api.rerender('1ffa1f76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VModal.vue"
export default component.exports